module.exports = require('preact-compat')
